<template>
  <!-- eslint-disable max-len -->
  <div class="bpc-table">
      
      <bpc-table-header :fields="fields" :filters="filters" :pagination="pagination" :view="view" :totalRows="items.length"></bpc-table-header>

      <b-table v-if="viewIsTable()" class="table-lg" show-empty
               stacked="md"
               :items="items"
               :fields="fields"
               :current-page="pagination.currentPage"
               :per-page="pagination.perPage"
               :filter="filter"
               :sort-by.sync="pagination.sortBy"
               :sort-desc.sync="pagination.sortDesc"
               :sort-direction="pagination.sortDirection"
               @filtered="onFiltered"
      >

        <!-- HEAD -->

        <!-- checked -->
        <template v-slot:head(checked)="row">
          <div class="custom-checkbox custom-control">
            <input type="checkbox" id="checkAll" class="custom-control-input" v-on:click="checkAll()">
            <label class="custom-control-label" for="checkAll">&nbsp;</label>
          </div>
        </template>

        <!-- img_url -->
        <template v-slot:head(img_url)="row">
          <i class="vsm-icon pe-7s-photo"></i>
        </template>

        <!-- img_url -->
        <template v-slot:head(format)="row">
          <i class="lnr-file-empty"></i>
        </template>


        <!-- CELL -->

        <!-- color -->
        <template v-slot:cell(color)="row">
          <div class="bar" :style="{ backgroundColor: row.value }"></div>
        </template>

        <!-- checked -->
        <template v-slot:cell(checked)="row">
          <div class="custom-checkbox custom-control">
            <input type="checkbox" :id="'checkRow'+row.index" class="custom-control-input" v-model="row.item.checked" v-on:click="checkOne()">
            <label class="custom-control-label" :for="'checkRow'+row.index">&nbsp;</label>
          </div>
        </template>

        <!-- img_url -->
        <template v-slot:cell(img_url)="row">
          <div class="avatar-icon-wrapper _avatar-icon-sm"><div class="avatar-icon"><img :src="row.value" alt=""></div></div>
        </template>

        <!-- format -->
        <template v-slot:cell(format)="row">
          <font-awesome-icon v-if="row.value == 'pdf'" icon="file-pdf"/>
          <font-awesome-icon v-else-if="row.value == 'excel'" icon="file-excel"/>
          <font-awesome-icon v-else-if="row.value == 'word'" icon="file-word"/>
          <font-awesome-icon v-else-if="row.value == 'image'" icon="file-image"/>
          <font-awesome-icon v-else-if="row.value == 'movie'" icon="film"/>
          <i v-else class="lnr-file-empty"></i>
        </template>

        <!-- code -->
        <template v-slot:cell(code)="{item}">
          <router-link :to="'/mockups/admin/resources/'+item.id" tag="button" class="btn btn-light border-0">
            {{ item.code }} 
          </router-link>
          <!-- <router-link v-if="item.color" :to="'/mockups/admin/resources/'+item.id" tag="button" class="btn text-white text-sm btn-sm" :style="{ backgroundColor: item.color }">
            {{ item.code }} 
          </router-link> -->
        </template>

        <!-- name -->
        <template v-slot:cell(name)="{item}">
          <router-link :to="'/mockups/admin/contacts/'+item.id" tag="button" class="btn-link">
            {{ item.name }}
          </router-link>
        </template>

        <!-- fullname -->
        <template v-slot:cell(fullname)="{item}">
          <router-link :to="'/mockups/admin/contacts/'+item.id" tag="button">
            <b-button variant="link" class="p-0 font-weight-normal">
              <span class="last">{{ item.name.last }}</span> <span class="first">{{ item.name.first }}</span>
            </b-button>
          </router-link>
        </template>

        <!-- birthdate -->
        <template v-slot:cell(birthdate)="row">
          {{ row.value.date }} <span v-if="row.value.age">({{ row.value.age }})</span>
        </template>

        <!-- date -->
        <template v-slot:cell(date)="row">
          {{ row.value }}
        </template>

        <!-- time -->
        <template v-slot:cell(time)="{item}">
          {{ item.time }} <span v-if="item.duration">({{ item.duration }})</span>
        </template>

        <!-- price -->
        <template v-slot:cell(price)="row">
          <span v-if="row.value">{{ row.value }} €</span>
        </template>

        <!-- relations -->
        <template v-slot:cell(relations)="row">
          <div class="avatar-wrapper avatar-wrapper-overlap">
            <div v-for="(value, key) in row.value" :key="key" class="avatar-icon-wrapper avatar-icon-sm">
              <b-dropdown toggle-class="p-0 mr-2" menu-class="dropdown-menu-lg" variant="link" no-caret right>
                <span slot="button-content">
                    <div class="icon-wrapper icon-wrapper-alt rounded-circle">
                        <img width="42" class="rounded-circle" :src="items[value.contact_id].img_url" alt="">
                    </div>
                </span>
                <bpc-mini-contact :item="items[value.contact_id]"></bpc-mini-contact>
              </b-dropdown>
            </div>
          </div>
        </template>

        <!-- contacts -->
        <template v-slot:cell(contacts)="{item}">
          <div class="avatar-wrapper avatar-wrapper-overlap">
            <div v-for="(value, key) in item.contacts" :key="key" class="avatar-icon-wrapper avatar-icon-sm">
              <b-dropdown toggle-class="p-0 mr-2" menu-class="dropdown-menu-lg" variant="link" no-caret right>
                <span slot="button-content">
                    <div class="icon-wrapper icon-wrapper-alt rounded-circle">
                        <img width="42" class="rounded-circle" :src="value.img_url" alt="">
                    </div>
                </span>
                <bpc-mini-contact :item="value"></bpc-mini-contact>
              </b-dropdown>
            </div>
          </div>
        </template>

        <!-- ongoing -->
        <template v-slot:cell(ongoing)="row">
          <button v-if="row.value.subscriptions" class="pl-0 py-0 btn-icon btn-icon-only btn btn-link btn-sm">
            <i class="vsm-icon pe-7s-id btn-icon-wrapper font-size-xlg"> </i><span class="p-0 ml-0 badge _badge-pill _badge-primary">{{row.value.subscriptions}}</span></button>
          <button v-if="row.value.bookings" class="pl-0 py-0 btn-icon btn-icon-only btn btn-link btn-sm">
            <i class="vsm-icon pe-7s-bookmarks btn-icon-wrapper font-size-xlg"> </i><span class="p-0 ml-0 badge _badge-pill _badge-primary">{{row.value.bookings}}</span></button>
          <button v-if="row.value.activities" class="pl-0 py-0 btn-icon btn-icon-only btn btn-link btn-sm">
            <i class="vsm-icon pe-7s-joy btn-icon-wrapper font-size-xlg"> </i><span class="p-0 ml-0 badge _badge-pill _badge-primary">{{row.value.activities}}</span></button>
          <button v-if="row.value.registrations" class="pl-0 py-0 btn-icon btn-icon-only btn btn-link btn-sm">
            <i class="vsm-icon pe-7s-ticket btn-icon-wrapper font-size-xlg"> </i><span class="p-0 ml-0 badge _badge-pill _badge-primary">{{row.value.registrations}}</span></button>
        </template>

        <!-- status -->
        <template v-slot:cell(status)="row">
          <div v-if="row.value == 'inactive'" class="badge badge-pill badge-danger">Inactive</div>
          <div v-if="row.value == 'active'" class="badge badge-pill badge-success">Active</div>
          <div v-if="row.value == 'confirmed'" class="badge badge-pill badge-success">Confirmed</div>
          <div v-if="row.value == 'booked'" class="badge badge-pill badge-success">Booked</div>
          <div v-if="row.value == 'waiting'" class="badge badge-pill badge-warning">Waiting</div>
          <div v-if="row.value == 'cancelled'" class="badge badge-pill badge-danger">Cancelled</div>
          <div v-if="row.value == 'paid'" class="badge badge-pill badge-success">Paid</div>
          <div v-if="row.value == 'to_pay'" class="badge badge-pill badge-warning">To pay</div>
        </template>
        
        <!-- status -->
        <template v-slot:cell(payment_status)="row">
          <div v-if="row.value == 'inactive'" class="badge badge-pill badge-danger">Inactive</div>
          <div v-if="row.value == 'active'" class="badge badge-pill badge-success">Active</div>
          <div v-if="row.value == 'confirmed'" class="badge badge-pill badge-success">Confirmed</div>
          <div v-if="row.value == 'booked'" class="badge badge-pill badge-success">Booked</div>
          <div v-if="row.value == 'waiting'" class="badge badge-pill badge-warning">Waiting</div>
          <div v-if="row.value == 'cancelled'" class="badge badge-pill badge-danger">Cancelled</div>
          <div v-if="row.value == 'paid'" class="badge badge-pill badge-success">Paid</div>
          <div v-if="row.value == 'to_pay'" class="badge badge-pill badge-warning">To pay</div>
        </template>
        
        <!-- actions -->
        <template v-slot:cell(actions)="row">
          <b-button-group>
            <router-link to="/mockups/admin/contacts/1" tag="button">
              <b-button variant="outline-link" class="border-0 btn-transition">
                <i class="vsm-icon pe-7s-note"></i>
              </b-button>
            </router-link>
            <b-button variant="outline-link" class="border-0 btn-transition">
              <i class="vsm-icon pe-7s-trash"></i>
            </b-button>
            <b-button variant="outline-link" class="border-0 btn-transition">
              <i class="vsm-icon pe-7s-more"></i>
            </b-button>
          </b-button-group>
        </template>

        <template slot="row-details" slot-scope="row">
          <b-card class="no-shadow">
            <ul class="list-group">
              <li class="list-group-item" v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value}}</li>
            </ul>
          </b-card>
        </template>

      </b-table>

      <!-- <div class="row m-1">
        <div v-for="(value, key) in items" :key="key" class="col-md-12 col-lg-6 col-xl-4">
          

                    <div class="card-hover-shadow profile-responsive card-border border-primary mb-3 card">
                      <div class="dropdown-menu-header">
                        <div class="dropdown-menu-header-inner bg-info">
                            <div class="menu-header-image opacity-2 dd-header-bg-6"></div>
                            <div class="menu-header-content text-left">
                                <div class="widget-content p-0">
                                    <div class="widget-content-wrapper">
                                        <div class="widget-content-left mr-3">
                                            <img width="42" class="rounded-circle" :src="value.img_url" alt="">
                                        </div>
                                        <div class="widget-content-left">
                                            <div class="widget-heading">{{value.name.last}} {{value.name.first}}</div>
                                            <div class="widget-subheading opacity-8">{{value.relation}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="value.contact_details.phone || value.contact_details.phone2 || value.contact_details.email || value.contact_details.email2" class="scroll-area-xs" style="height: auto">
                        <VuePerfectScrollbar class="scrollbar-container">
                          <ul class="contact-details">
                            <li>
                              <a v-if="value.contact_details.phone" href="javascript:void(0);" class="btn btn-link">
                                <i class="pe-7s-phone mr-2"></i>
                                {{value.contact_details.phone}}</a>
                            </li>
                            <li>
                              <a v-if="value.contact_details.phone2" href="javascript:void(0);" class="btn btn-link">
                                <i class="pe-7s-phone mr-2"></i>
                                {{value.contact_details.phone2}}</a>
                            </li>
                            <li>
                              <a v-if="value.contact_details.email" href="javascript:void(0);" class="btn btn-link">
                                {{value.contact_details.email}}</a>
                            </li>
                            <li>
                              <a v-if="value.contact_details.email2" href="javascript:void(0);" class="btn btn-link">
                                {{value.contact_details.email2}}</a>
                            </li>
                          </ul>
                        </VuePerfectScrollbar>
                    </div>
                    <ul class="nav flex-column">
                        <li class="nav-item-divider mb-0 nav-item"></li>
                    </ul>
                    <div class="grid-menu grid-menu-2col overflow-hidden">
                        <div class="no-gutters row">
                            <div class="col-sm-6">
                                <button class="_btn-icon-vertical _btn-transition _btn-transition-alt _pt-2 _pb-2 btn _btn-outline-warning"><i class="pe-7s-chat _icon-gradient _bg-amy-crisp _btn-icon-wrapper mr-2"> </i>Message</button>
                            </div>
                            <div class="col-sm-6">
                                <button class="_btn-icon-vertical _btn-transition _btn-transition-alt _pt-2 _pb-2 btn _btn-outline-danger"><i class="pe-7s-ticket _icon-gradient _bg-love-kiss _btn-icon-wrapper mr-2"> </i><b>View</b>
                                </button>
                            </div>
                        </div>
                    </div>
                    </div>

        </div>
      </div> -->

      <bpc-table-footer :pagination="pagination" :totalRows="items.length"></bpc-table-footer>

  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faStar,
  faPlus,
  faTrash,
  faPlay,
  faForward,
  faRocket,
  faQuestion,
  faEdit,
  faEllipsisH,
  faFile,
  faFilePdf,
  faFileWord,
  faFileExcel,
  faFileImage,
  faFilm,
} from '@fortawesome/free-solid-svg-icons';


import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import BpcTableHeader from '@/mockups/layouts/components/BpcTableHeader.vue';
import BpcTableFooter from '@/mockups/layouts/components/BpcTableFooter.vue';
import BpcMiniContact from '@/mockups/mini/BpcMiniContact.vue';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

library.add(
  faStar,
  faPlus,
  faTrash,
  faPlay,
  faForward,
  faRocket,
  faQuestion,
  faEdit,
  faEllipsisH,
  faFile,
  faFilePdf,
  faFileWord,
  faFileExcel,
  faFileImage,
  faFilm,
);

export default {
  components: {
    'font-awesome-icon': FontAwesomeIcon,
    BpcTableHeader,
    BpcTableFooter,
    BpcMiniContact,
    VuePerfectScrollbar,
  },
  props: {
    items: Array,
    fields: Array,
    selection: Array,
    filters: Object,
  },
  data: () => ({
    header: {
      heading: 'Contacts',
      subheading: 'Contacts of your sport center',
      icon: '', // 'pe-7s-users icon-gradient bg-tempting-azure',
      breadcrumb: ['Dashboard', 'Contacts'],
      links: ['Help', 'Settings'],
      actions: {
        delete: true, bulk: true, new: true, edit: false, actions: true,
      },
    },
    pagination: {
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 20, 50, 100, 200],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
    },
    filter: null,
    view: 'table',
    modalInfo: { title: '', content: '' },
  }),
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }));
    },
  },
  methods: {
    info(item, index, button) {
      this.modalInfo.title = `Row index: ${index}`;
      this.modalInfo.content = JSON.stringify(item, null, 2);
      this.$root.$emit('bv::show::modal', 'modalInfo', button);
    },
    resetModal() {
      this.modalInfo.title = '';
      this.modalInfo.content = '';
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    checkOne() {
      console.log(this.items);
      let mySelection = this.selection;
      for (let i = 0; i < this.items.length; i += 1) {
        if (this.items[i].checked) {
          mySelection.push(i);
        }
      }
      console.log(mySelection);
      this.$emit("update-selection", mySelection);
    },
    checkAll() {
      console.log(items);
    },
    viewIsTable() {
      return this.view == 'table';
    },
    viewIsCards() {
      return this.view == 'cards';
    }
  },
};
</script>

<style>
.card-body {
  padding: 0 !important;
}
.card-title {
  padding: 1.25rem 0.825rem 0.5rem;
}
.card-body table {
  margin-bottom: 0;
}
.card-body table tr:last-child {
  border-bottom: 1px solid #e9ecef;
}
.table thead th {
  background-color: #f3f3f3;
  border-bottom-width: 1px !important;
}
.table td {
  vertical-align: middle;
}
.table th.color {
    width: 15px;
    padding: 0;
}
.table td.color {
    padding: 3px 0 3px 10px;
}
.table td.color .bar {
    position: relative;
    height: 38px;
    width: 4px;
    border-radius: .3rem;
    opacity: .6;
}
.table th.check, .table td.check {
  width: 40px;
  text-align: center;
}
.table th.avatar {
  width: 46px;
  padding: 0 0px 0 0 !important;
  vertical-align: middle;
  text-align: center;
}
.table th.avatar i {
  font-size: 22px;
  color: rgba(0,0,0,0.3);
  /* border: 1px solid; */
  border-radius: 50%;
  width: 38px;
  height: 38px;
  line-height: 38px;
  background: #fff; /*rgba(0,0,0,0.05);*/
  margin-right: 2px;
}
.table td.avatar {
  padding: 5px 0px 0 0;
}
.table th.format {
  width: 30px;
  padding: 0 !important;
  vertical-align: middle;
  text-align: center;
}
.table td.format {
  padding: 0 !important;
  vertical-align: middle;
  text-align: center;
}
.table th.format i, .table td.format i, .table td.format svg {
  font-size: 20px;
  color: #999;
}
.table th.code {
  width: 50px;
}
.table td.code .btn {
  white-space: nowrap;;
}
.table td.date > div {
  white-space: nowrap;;
}
.table td.time > div {
  white-space: nowrap;;
}
.table td.duration > div {
  white-space: nowrap;;
}
.table td.name .last {
  text-transform: uppercase;
}
.table td.relations {
  padding-top: 8px !important;
  padding-bottom: 0px !important;
}
.table td.relations .avatar-wrapper {
  white-space: nowrap;;
}
.table td.relations .avatar-wrapper .icon-wrapper {
  display: block;
  width: 44px;
  height: 44px;
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
  opacity: 1;
  border-radius: 50px;
  border: #fff solid 3px;
  overflow: hidden;
  width: 34px;
  height: 34px;
}
.table td.relations .avatar-wrapper .icon-wrapper img {
  width: 100%;
  height: 100%;
}
.table td.relations .avatar-wrapper-overlap .avatar-icon-wrapper.avatar-icon-sm {
  margin-left: -25px;
}
.table th.status {
  width: 80px;
}
.table td.price > div {
  white-space: nowrap;;
}
.table th.actions {
  width: 110px;
}
.table td.actions {
  padding-top: 0.825rem;
  padding-bottom: 0.825rem;
}
.table td.actions .btn {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  width: 30px;
  text-align: center;
  font-size: 1rem;
}
.table td.actions .btn-link:hover {
  background-color: #e9ecef;
  border-radius: 3px;
}
</style>
